import { render, staticRenderFns } from "./ExportCodeAsViewer.vue?vue&type=template&id=a4e85382&scoped=true&"
import script from "./ExportCodeAsViewer.vue?vue&type=script&lang=js&"
export * from "./ExportCodeAsViewer.vue?vue&type=script&lang=js&"
import style0 from "./ExportCodeAsViewer.vue?vue&type=style&index=0&id=a4e85382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e85382",
  null
  
)

export default component.exports